import IconHOC from 'shared/legacy/icons/v2/IconHOC';
import { ReactComponent as BriefcaseIcon } from './briefcase.svg';

export const Briefcase = IconHOC(BriefcaseIcon);
